import { createSlice } from '@reduxjs/toolkit'
import { ApiState } from "@baseTypes/baseType";
import {applyExtraReducerWithPaths} from "@utils/applyExtraReducer";
import {createThunk} from "@utils/createThunk";
import {AppDispatch, RootThunkAPI} from "../../../index";

export interface Good {
    title: string
    group: number
    id: number
}
interface GoodsGroup {
    id: number
    qualifier: string
}
interface GoodsCategory {
    id: string
    title: string
}
interface Goods extends ApiState {
    data: Good[]
}
interface GoodsGroups extends ApiState {
    data: GoodsGroup[]
}
interface GoodsCategories extends ApiState {
    data: GoodsCategory[]
}

interface GoodsState {
    goods: Goods
    goodsGroups: GoodsGroups
    goodsCategories: GoodsCategories
}

const initialState: GoodsState = {
    goods: {
        data: [],
        apiError: undefined,
        isApiLoading: false,
    },
    goodsGroups: {
        data: [],
        apiError: undefined,
        isApiLoading: false,
    },
    goodsCategories: {
        data: [],
        apiError: undefined,
        isApiLoading: false,
    }
}

export const fetchPartnersGoodsRequest = createThunk<Good[], {}>('/goods')({
    prefix: 'fetchPartnersGoodsRequest',
});
export const fetchPartnersGoods = () => async (dispatch: AppDispatch) => {
    return await dispatch(fetchPartnersGoodsRequest({})).unwrap();
};

export const fetchPartnersGoodsGroupsRequest = createThunk<GoodsGroup[], {}>('/goodsGrps')({
    prefix: 'fetchPartnersGoodsGroupsRequest',
});
export const fetchPartnersGoodsGroups = () => async (dispatch: AppDispatch) => {
    return await dispatch(fetchPartnersGoodsGroupsRequest({})).unwrap();
};

export const fetchPartnersGoodsCategoriesRequest = createThunk<GoodsCategory[], {}>('/productCategory')({
    prefix: 'fetchPartnersGoodsCategoriesRequest',
});
export const fetchPartnersGoodsCategories = () => async (dispatch: AppDispatch) => {
    return await dispatch(fetchPartnersGoodsCategoriesRequest({})).unwrap();
};



const goodSlice = createSlice({
    name: 'goodsSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        applyExtraReducerWithPaths(builder, fetchPartnersGoodsRequest, { sliceTarget: ['goods'] });
        applyExtraReducerWithPaths(builder, fetchPartnersGoodsGroupsRequest, { sliceTarget: ['goodsGroups'] });
        applyExtraReducerWithPaths(builder, fetchPartnersGoodsCategoriesRequest, { sliceTarget: ['goodsCategories'] });
    },
})

export const actions = { ...goodSlice.actions, fetchPartnersGoods, fetchPartnersGoodsGroups, fetchPartnersGoodsCategories }
export default goodSlice.reducer